import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IPromocode } from '../../types/Promocode';

export enum Gender {
  MALE = '1',
  FEMALE = '2',
}

type User = {
  _id: string | null;
  name: string;
  phone: string;
  dob?: string;
  gender?: Gender;
  email?: string;
  verifiedEmail?: boolean;
  tg_username?: string;
  promocodes?: IPromocode[];
  language: string;
  isAuth: boolean;
  profile_picture: string;
  lastOrderDate: string | null;
  // Непустое значение = открыт последний шаг регистрации, ввод имени.
};

const getDefaultLanguage = (): string => {
  const storedLang = localStorage.getItem('language');

  return storedLang === 'ru' || storedLang === 'uz' ? storedLang : 'uz';
};

const initialState: User = {
  _id: null,
  name: 'EVOS',
  phone: '+998901234567',
  tg_username: '',
  gender: undefined,
  dob: undefined,
  email: undefined,
  verifiedEmail: false,
  language: getDefaultLanguage(),
  promocodes: [],
  isAuth: false,
  profile_picture: '',
  lastOrderDate: null,
  // Только в памяти, в отличие от прежнего флага needsName: шаг имени держится
  // на коде из СМС, а тот живёт 120 секунд и перезагрузку не переживает.
  // Пережил бы флаг — пользователь застрял бы в шторке, которую нечем закрыть.
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setAuth: (state, action: PayloadAction<User>) => {
      state.isAuth = action.payload.isAuth;
    },
    setUser(state, action: PayloadAction<User>) {
      Object.assign(state, action.payload);
    },
    addPromocode(state, action: PayloadAction<IPromocode>) {
      state.promocodes?.push(action.payload);
    },
    setLanguage(state, action: PayloadAction<string>) {
      state.language = action.payload;
    },
    clearUser(state) {
      state._id = null;
      state.name = '';
      state.phone = '';
      state.language = getDefaultLanguage();
      state.gender = undefined;
      state.dob = undefined;
      state.email = undefined;
      state.verifiedEmail = false;
      state.tg_username = '';
      state.promocodes = [];
      state.isAuth = false;
      state.profile_picture = '';
    },
  },
});

export const {
  setUser,
  clearUser,
  addPromocode,
  setLanguage,
  setAuth,
} =
  userSlice.actions;
export default userSlice.reducer;
